export type FileUploadPartResponseDataFromType = "Header";
export type FileUploadState =
  | "Preparing"
  | "Uploading"
  | "Compoining"
  | "Completed"
  | "Failed";

export enum ProductNameContract {
  Studio = "Studio",
  Robot = "Robot",
  AndroidAutomation = "AndroidAutomation",
  IOSAutomation = "IOSAutomation",
  AndroidAutomationV2 = "AndroidAutomationV2",
  OCROffline = "OCROffline",
}

export enum ProductSkuContract {
  Community = 1,
  Enterprise = 2,
}

export enum InstallPackageStatus {
  ToBeUploaded = 0,
  Ready = 1,
  Published = 2,
  Deleted = 3,
}

export interface InstallPackageList {
  id: string;
  packageName?: string;
  productName: ProductNameContract;
  sku: string;
  description?: string;
  version?: string;
  fileName?: string;
  filePath?: string;
  extFiles: Record<string, number>;
  publishedAt?: string;
  status: InstallPackageStatus;
  createdAt?: string;
  fileSize?: number;
  uploadAt?: string;
  uploadByName?: string;
}

export interface CreateInstallPackage {
  packageName?: string;
  productName: ProductNameContract;
  sku: ProductSkuContract;
  description?: string;
  version?: string;
  fileName?: string;
  fileSize?: number;
}

export interface UploadComplete {
  fileName?: string;
  fileSize?: number;
  isMainfileNotice?: boolean;
}
